import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { Box, Chip, CircularProgress, Dialog } from "@mui/material";
import { Settings } from "@mui/icons-material";
import EditIcon from "@mui/icons-material/Edit";
import useRequireAuth from "../../utils/useRequireAuth";
import { ReactComponent as CloseModalImg } from "../../assets/images/closeModalImg.svg";
import { useLazyFetchPersonInTableQuery } from "../../utils/customer/customerTable";
import CustomDropdown from "../UniversalComponents/CustomDropdown";
import { mySpaceTableSendAccess } from "../../utils/api/mySpaceApi";
import { pushAlert } from "../../utils/alertSlice";
import Button from "../UniversalComponents/DefaultButton";
import DocumentIcon from "../../utils/utilityFunctions/iconUtility";
import { truncateString } from "../../utils/utilityFunctions/stringUtility";
import moment from "moment";
import ToolTipComponent from "../UniversalComponents/ToolTipComponent";
import withPortalHOC from "../UniversalComponents/WithPortalHOC";
import List from "../UniversalComponents/ListComponent";

const PortalList = withPortalHOC(List);

const ShareFileModal = ({ open, close, sharedAssetInfo }) => {
  // Define the DROPDOWN_OPTIONS array for custom dropdown
  const DROPDOWN_OPTIONS = {
    selectedOptionBgColor: "#F3F5F7",
    options: [
      // {
      //   text: "Can View",
      //   data: {
      //     id: 1,
      //     label: "Can View",
      //     value: "read",
      //   },
      //   icon: <RemoveRedEyeIcon className="mr-3 text-[#969BA9] group-hover:text-[#1D4469]" />,
      //   onClick: (option) => handleAccessTypeSelection(option),
      //   afterDivider: false,
      // },
      {
        text: "Only Edit",
        id: 2,
        data: {
          id: 2,
          label: "Only Edit",
          value: "write",
        },
        icon: <EditIcon className="mr-3 text-[#969BA9] group-hover:text-[#1D4469]" />,
        onClick: (option) => handleAccessTypeSelection(option),
        afterDivider: false,
      },
      {
        text: "Add, Edit, Delete",
        id: 3,
        data: {
          id: 3,
          label: "Add, Edit, Delete",
          value: "delete",
        },
        icon: <Settings className="mr-3 text-[#969BA9] group-hover:text-[#1D4469]" />,
        onClick: (option) => handleAccessTypeSelection(option),
        afterDivider: false,
      },
    ],
  };
  const dispatch = useDispatch();

  const companyId = JSON.parse(localStorage.getItem("company_data")).company_id;
  const [showPersonList, setShowPersonList] = useState(false);
  const [authorizedUsers, setAuthorizedUsers] = useState([]);
  const [suggestedUsersList, setSuggestedUsersList] = useState();
  const [selectedAccessType, setSelectedAccessType] = useState(DROPDOWN_OPTIONS?.options[0].data);
  const [isApiLoading, setIsApiLoading] = useState(false);
  const [selectedPersons, setSelectedPersons] = useState([]);

  const { token } = useRequireAuth();

  const divRef = useRef();

  const [fetchPersonInTable, { data: personTableData, isFetching }] = useLazyFetchPersonInTableQuery();
  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token, data: data, companyId: companyId });
  };

  const handleAccessTypeSelection = (option) => {
    setSelectedAccessType(option);
  };

  useEffect(() => {
    // console.log("fetchPerson effect token", token);
    if (token) fetchPersonData("");
  }, [token]);

  const handleSubmit = async (event) => {
    event.preventDefault();
  };

  const handleSendAccess = async () => {
    try {
      setIsApiLoading(true);
      const authorizedUserIds = authorizedUsers.map((user) => user.uuid);

      const payload = {
        containerId: sharedAssetInfo?.id,
        access: selectedAccessType?.value,
        userIds: selectedPersons.map((person) => person?.value) || [],
      };

      const response = await mySpaceTableSendAccess({ body: payload });
      if (response?.success) {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "success" }));
        close();
      } else {
        dispatch(pushAlert({ visible: true, message: response?.message, type: "danger" }));
      }
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: error?.message, type: "danger" }));
    } finally {
      setIsApiLoading(false);
    }
  };

  const fileFolderToolTipHtml = (folderData) => {
    return (
      <div className="flex flex-col gap-1">
        <span className="text-[10px] font-light text-[#383838B2]">
          <span className="font-normal">Name: </span>
          {folderData?.display_name}
        </span>
        <span className="text-[10px] font-light text-[#383838B2]">
          <span className="font-normal">Type: </span>
          {folderData?.mimetype}
        </span>
        <span className="text-[10px] font-light text-[#383838B2]">
          <span className="font-normal">Created By: </span>
          {folderData?.created_by}
        </span>
        <span className="text-[10px] font-light text-[#383838B2]">
          <span className="font-normal">Created Date: </span>
          {moment(folderData?.created_at).format("DD/MM/YYYY HH:mm")}
        </span>
      </div>
    );
  };

  useEffect(() => {
    setSuggestedUsersList(
      personTableData?.data?.map((person) => {
        return {
          value: person?.uuid,
          label: person?.name,
          subLabel: person?.email,
        };
      })
    );
  }, [personTableData?.data]);

  return (
    <Dialog open={open} fullWidth>
      <div className="flex items-center justify-between p-3 border-b-[1px] border-[#AFAFAF] rounded-lg rounded-b-none">
        <h3 className="flex items-center gap-2 text-16 font-500 text-[#434852]">
          Share
          <span className=" flex items-center gap-1 px-2 py-[1px] rounded-md">
            "
            <DocumentIcon
              type={sharedAssetInfo?.type}
              filename={sharedAssetInfo?.mimetype}
              fill={sharedAssetInfo?.type === "folder" ? sharedAssetInfo?.code : null}
            />
            <ToolTipComponent
              text={fileFolderToolTipHtml(sharedAssetInfo)}
              title={sharedAssetInfo?.display_name}
              disable={sharedAssetInfo?.type === "folder"}
            >
              {truncateString({ str: sharedAssetInfo?.display_name })}"
            </ToolTipComponent>
          </span>
          to
        </h3>
        <button
          onClick={close}
          type="button"
          className="text-454545 bg-transparent flex justify-center items-center"
          data-modal-hide="assets-modal"
        >
          <CloseModalImg className="w-3 h-3" />
        </button>
      </div>
      <form
        onSubmit={handleSubmit}
        className="w-full lg:max-h-[70vh] p-3 flex flex-col gap-4 overflow-x-hidden no-scrollbar"
      >
        <div className="basis-5/5">
          <label htmlFor="Designation" className="block mb-2 text-434852 text-14 font-400 ">
            Name
          </label>
          <div
            ref={divRef}
            onClick={(event) => {
              event.stopPropagation();
              setShowPersonList(true);
            }}
            className="border-[DFE2E5] border flex items-center rounded-lg cursor-pointer"
          >
            <Box
              className="w-[100%] border-none text-[12px] font-[400] text-[#848687] focus:ring-0"
              sx={{
                display: "flex",
                maxHeight: 50, // Set a fixed max height to trigger scroll
                overflowX: "auto", // Enable horizontal scrolling if content exceeds max height
                padding: "4px", // Add some padding around the chips
                width: "100%", // Make the startAdornment take full width of the input field
                "&::-webkit-scrollbar": {
                  display: "none", // Hide the scrollbar
                },
              }}
            >
              {selectedPersons.map((person) => (
                <Chip label={person.label} sx={{ margin: "2px" }} />
              ))}
            </Box>
            <CustomDropdown mode={"vertical"} options={DROPDOWN_OPTIONS} />
            {showPersonList && (
              <PortalList
                open={showPersonList}
                onClose={() => {
                  setShowPersonList(false);
                }}
                containerRef={divRef}
                options={suggestedUsersList}
                selectedOptions={selectedPersons}
                // setSelectedOptions={setSelectedOptions}
                onOptionClick={(option) => setSelectedPersons(option)}
                multiSelect={true}
                showSearch={true}
                personList={true}
              />
            )}
          </div>
        </div>

        <div className="">
          <label htmlFor="chart_of_accounts_id" className="block mb-2 text-sm text-434852">
            Add A Message
          </label>
          <textarea
            name="descriptions"
            placeholder="Type Something..."
            className="bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full h-24 resize-none"
          />
        </div>
        <div className={`flex justify-end  item-center text-md w-full`}>
          <div className="flex items-center">
            <Button
              className={"min-w-[130px]"}
              onClick={handleSendAccess}
              isDisabled={selectedPersons?.length === 0 || isApiLoading}
            >
              {isApiLoading ? (
                <div className="flex items-center gap-2">
                  <CircularProgress size={16} color="inherit" />
                  Sending...
                </div>
              ) : (
                "Send"
              )}
            </Button>
          </div>
        </div>
      </form>
    </Dialog>
  );
};

export default ShareFileModal;
